/**
 * Справочники и опции фильтров раздела «Клиенты».
 *
 * Счётчики статусов считаются из мока (когда подключим BE — придут с
 * `/admin/dashboard/summary` или отдельным count-эндпоинтом). Порядок и
 * цвета точек совпадают со StatusPill.
 */

import {MOCK_CLIENTS} from './mocks';
import type {StatusOption, SubscriptionStatus} from './types';

/** Подписи и цвета статусов — без счётчиков (их даёт getStatusCounts) */
export const STATUS_META: {value: SubscriptionStatus; label: string; dot: string}[] = [
  {value: 'active', label: 'Активна', dot: '#1B7A54'},
  {value: 'trial', label: 'Триал', dot: '#2C5CDB'},
  {value: 'trial_expired', label: 'Триал истёк', dot: '#B4501B'},
  {value: 'awaiting_card', label: 'Ожидает карту', dot: '#B07908'},
  {value: 'past_due', label: 'Просрочена', dot: '#C6362C'},
  {value: 'blocked', label: 'Заблокирована', dot: '#55524C'},
  {value: 'cancelled', label: 'Отменена', dot: '#7C808A'},
];

export const STATUS_OPTIONS: StatusOption[] = STATUS_META.map((m) => ({
  ...m,
  count: MOCK_CLIENTS.filter((c) => c.subscriptionStatus === m.value).length,
}));

/** Всего клиентов (для счётчика в шапке). */
export const CLIENTS_TOTAL = MOCK_CLIENTS.length;

/** Специализации врачей (BUSINESS_LOGIC §6; фиксированный список). */
export const SPECIALIZATION_OPTIONS = [
  'Терапевт',
  'Хирург',
  'Ортодонт',
  'Гигиенист',
  'Ортопед',
  'Пародонтолог',
] as const;

/** Языки кабинета. */
export const LANGUAGE_OPTIONS = ['Русский', 'Кыргызча'] as const;

/**
 * Дедуп телефона: один номер = один аккаунт (ADMIN_SPEC §5.4). Возвращает
 * имя клиента-владельца номера или null, если свободен. Сравнение по цифрам.
 * BE-версия — 409 от `POST /admin/clients` / отдельная проверка.
 */
const digits = (phone: string): string => phone.replace(/\D/g, '');

export const phoneOwner = (phone: string): string | null => {
  const d = digits(phone);
  if (d.length < 9) return null;
  return MOCK_CLIENTS.find((c) => digits(c.adminPhone) === d)?.name ?? null;
};
